import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-main-autre-examamen',
  imports: [RouterOutlet],
  templateUrl: './main-autre-examamen.component.html',
  styleUrl: './main-autre-examamen.component.scss'
})
export class MainAutreExamamenComponent {}
